<template>
  <div id="app">
    <div
      class="app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar"
    >
      <LoaderPacman v-if="!mounted || !check" />
      <div v-else>
        <template v-if="authenticated">
          <HeaderComponent />
          <div class="app-main">
            <SidebarComponent />
            <div class="app-main__outer">
              <div class="app-main__inner">
                <router-view :key="$route.fullPath" v-if="authenticated && user" />
                <LoaderApp v-else></LoaderApp>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <Login></Login>
        </template>
      </div>
    </div>
    <div class="modal-mask"></div>
  </div>
</template>
<script>
import HeaderComponent from "@/components/layouts/HeaderComponent";
import SidebarComponent from "@/components/layouts/SidebarComponent";
import Login from "@/components/views/Login";
import LoaderPacman from "@/components/loaders/LoaderPacman";
import LoaderApp from "@/components/loaders/LoaderApp";
import { mapGetters, mapActions } from "vuex";
import Axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";
import "bootstrap";
export default {
  components: {
    HeaderComponent,
    SidebarComponent,
    Login,
    LoaderPacman,
    LoaderApp,
  },
  data() {
    return {
      mounted: false,
    };
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
      check: "auth/check",
    }),
    ...mapActions({
      logoutAction: "auth/logout",
      setTokenMutation: "auth/deleteToken",
    }),
  },
  created() {
    Axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (err) => {
        if (err.response.status == 401) {
          this.setTokenMutation;
          this.$router.push({
            name: "Login",
          });
          Swal.fire({
            icon: "error",
            title: "Sesión vencida",
            text: `Ha terminado el tiempo de tu sesión, por favor inicia sesión nuevamente`,
          });
          return;
        }
        throw err;
      }
    );
  },
  mounted() {
    // console.clear();
    this.inicializar();
    this.mounted = true;
  },
  watch: {
    $route() {
      let container = document.getElementsByClassName("app-container")[0];
      if (container.classList.contains("sidebar-mobile-open")) {
        container.classList.remove("sidebar-mobile-open");
        let button = document.getElementsByClassName("mobile-toggle-nav")[0];
        button.classList.remove("is-active");
      }
    },
  },
  methods: {
    inicializar() {
      $(document).ready(() => {
        // Stop Bootstrap 4 Dropdown for closing on click inside
        $(".dropdown-menu").on("click", function (event) {
          var events = $._data(document, "events") || {};
          events = events.click || [];
          for (var i = 0; i < events.length; i++) {
            if (events[i].selector) {
              if ($(event.target).is(events[i].selector)) {
                events[i].handler.call(event.target, event);
              }

              $(event.target)
                .parents(events[i].selector)
                .each(function () {
                  events[i].handler.call(this, event);
                });
            }
          }
          event.stopPropagation(); //Always stop propagation
        });
        // Responsive
        $(window).on("resize", function () {
          var win = $(this);
          if (win.width() < 1250) {
            $(".app-container").addClass("closed-sidebar-mobile closed-sidebar");
          } else {
            $(".app-container").removeClass("closed-sidebar-mobile closed-sidebar");
          }
        });
      });
    },
  },
};
</script>
